import { Component, Inject, Renderer2 } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { CookieService } from 'ngx-cookie-service';
import { ApiService } from 'src/services/apiService';
import { AuthService } from 'src/services/auth.service';
import { DOCUMENT } from '@angular/common';
import { Title } from '@angular/platform-browser';  // استيراد خدمة Title
import { environment } from 'src/environments/environment';
import { Router, NavigationEnd } from '@angular/router';
import { filter } from 'rxjs/operators';

declare const readpage: any;

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})


export class AppComponent {
  date:any;
  title = 'GovNet';
  titleProject = "";
    isReading = false;
  constructor(private titleService: Title,private apiService: ApiService,private translate: TranslateService,
    private cookieService: CookieService,@Inject(DOCUMENT) private document: Document,private renderer: Renderer2,private authService:AuthService,private router: Router
    ) {
      this.titleProject=environment.Title;

      this.titleService.setTitle(this.titleProject);

    var lang=this.cookieService.get('lang');

    if(lang=="" || lang==null){
      this.cookieService.set('lang','ar');
      translate.setDefaultLang('ar');
    }else{
      translate.use(lang);
    }


    if (this.cookieService.get('lang') === 'ar') {
      this.renderer.setAttribute(this.document.body, 'style', 'direction:rtl');
    } else {
      this.renderer.setAttribute(this.document.body, 'style', 'direction:ltr');
    }

    

  }

  toggleRead() {
  const url =
    "//app-me.readspeaker.com/cgi-bin/rsent?customerid=9023&lang=ar_ar&voice=Yasmin&readid=contentToRead&url=";

  if (!this.isReading) {

    setTimeout(() => {
      readpage(url);
    }, 300);

    this.isReading = true;

  } else {

    if ((window as any).rs_stop) {
      (window as any).rs_stop();
    }

    this.isReading = false;
  }
}

  ngOnInit() {
     this.authService.initTokenFromUrl();

      this.router.events
    .pipe(filter(event => event instanceof NavigationEnd))
    .subscribe(() => {

      setTimeout(() => {

        if ((window as any).applyAccessibilitySettings) {
          (window as any).applyAccessibilitySettings();
        }

      }, 100);

    });


    //this.apiService.initializeTimer();
  }
  
  // currentLanguage: string|undefined;
  // globalTranslations: any;

  // constructor(private translateService:TranslateService,private cookieService: CookieService) {
  //   // translateService.setDefaultLang('ar');

  //   // translateService.addLangs(['en', 'ar']);

  //   // const browserLang = translateService.getBrowserLang( );

  //   // translateService.use(browserLang && browserLang.match(/en|ar/) ? browserLang : 'ar');

  //   // this.currentLanguage = this.cookieService.get('language') || this.translateService.getBrowserLang();
  //   // this.translateService.setDefaultLang('en');
  //   // this.translateService.use(this.currentLanguage!);
  //   // this.translateService.getTranslation(this.currentLanguage!).subscribe(translations => {
  //   //   this.globalTranslations = translations;
  //   // });



  // }
}



